import IRepository from "data/IRepository";
import AresBasicInfoDTO from "features/ares/dtos/AresBasicInfoDTO";
import IAresService from "./IAresService";
import { injectable } from "inversify";
import { inversifyContainer } from "infrastructure/ioc/ioc.container";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { getRouteParams } from "features/shared/helpers/routeParams";
import { Ares_AresBasic } from "data/endpoints";
import DataQuery from "data/DataQuery";
import { Nullable } from "features/shared/types/nullable";

@injectable()
export default class AresService implements IAresService {
  private readonly _aresRepository: IRepository<AresBasicInfoDTO>;

  constructor() {
    this._aresRepository = inversifyContainer.get<
      IRepository<AresBasicInfoDTO>
    >(IocTypes.Repository);
  }

  async fetchAresBasicInfo(
    companyRegistrationNumber: string
  ): Promise<Nullable<AresBasicInfoDTO>> {
    // query
    const query: DataQuery = {
      url: Ares_AresBasic,
      routeParams: getRouteParams(
        "companyRegistrationNumber",
        companyRegistrationNumber
      ),
    };

    try {
      const result = await this._aresRepository.getOne(query);
      return result;
    } catch (error) {
      // in case of not found or error
      return null;
    }
  }
}
